import React, { Component } from "react";
import PlayerRankingTable from "../../components/results/PlayerRankingTable";
import DivisionTabsContainer from "../DivisionTabsContainer";

class PlayerRankingContainer extends Component {
  state = {
    sort: "g",
    selectedPhase: "all",
    anchorElPhase: null,
  };

  selectPhase = (phaseKey) => {
    this.setState({ selectedPhase: phaseKey, anchorElPhase: null });
  };

  handleMenuPhase = (event) => {
    this.setState({ anchorElPhase: event.currentTarget });
  };

  handleClosePhase = () => {
    this.setState({ anchorElPhase: null });
  };

  handleSortChange = (e, s) => {
    this.setState({ sort: s });
  };

  render() {
    const playerPointsPlayedKey = Object.keys(
      this.props.tournament.playerPoints || {}
    ).find((p) => this.props.tournament.playerPoints[p].type === "3");
    let rankingPerDivision = {};
    const matchIdsPerTeam = {};
    this.props.matches.forEach((match) => {
      let poule = this.props.poulesByKey[match.poule] || {};
      if (
        this.state.selectedPhase === "all" ||
        Number(this.state.selectedPhase) === poule.fase
      ) {
        if (poule) {
          let pouleKeyName = poule.fase;
          if (poule.bracket) {
            let bracket = this.props.bracketsByKey[poule.bracket] || {};
            pouleKeyName =
              poule.bracketRound === bracket.size && !bracket.subBracketTo
                ? poule.fase
                : poule.fase + "-" + poule.bracketRound + "-" + poule.bracket;
          }
          const team1 = this.props.teams.find(
            (t) =>
              t["poule" + pouleKeyName] === match.poule &&
              t["numInPoule" + pouleKeyName] === match.team1
          );
          const team2 = this.props.teams.find(
            (t) =>
              t["poule" + pouleKeyName] === match.poule &&
              t["numInPoule" + pouleKeyName] === match.team2
          );
          if (team1) {
            if (matchIdsPerTeam[team1.id] === undefined) {
              matchIdsPerTeam[team1.id] = [];
            }
            matchIdsPerTeam[team1.id].push(match.id);
          }
          if (team2) {
            if (matchIdsPerTeam[team2.id] === undefined) {
              matchIdsPerTeam[team2.id] = [];
            }
            matchIdsPerTeam[team2.id].push(match.id);
          }
        }

        let playerGoals = match.goals || [];
        playerGoals.forEach((g) => {
          let player = this.props.playersByKey[g] || {};
          let team = this.props.teamsByKey[player.team] || {};
          let divisionId = team.division;
          if (player && divisionId) {
            if (rankingPerDivision[divisionId] === undefined) {
              rankingPerDivision[divisionId] = {};
            }
            if (rankingPerDivision[divisionId][player.id] === undefined) {
              rankingPerDivision[divisionId][player.id] = {};
            }
            if (rankingPerDivision[divisionId][player.id]["g"] === undefined) {
              rankingPerDivision[divisionId][player.id]["g"] = 0;
            }
            rankingPerDivision[divisionId][player.id]["g"]++;
          }
        });

        let playerPoints = match.playerPoints || {};
        Object.keys(playerPoints).forEach((key) => {
          let points = playerPoints[key];
          points.forEach((p) => {
            let player = this.props.playersByKey[p] || {};
            let team = this.props.teamsByKey[player.team] || {};
            let divisionId = team.division;
            if (player && divisionId) {
              if (rankingPerDivision[divisionId] === undefined) {
                rankingPerDivision[divisionId] = {};
              }
              if (rankingPerDivision[divisionId][player.id] === undefined) {
                rankingPerDivision[divisionId][player.id] = {};
              }
              if (
                rankingPerDivision[divisionId][player.id][key] === undefined
              ) {
                rankingPerDivision[divisionId][player.id][key] = 0;
              }
              rankingPerDivision[divisionId][player.id][key]++;
            }
          });
        });
      }
    });

    let ranking = {};
    Object.keys(rankingPerDivision).forEach((r) => {
      if (ranking[r] === undefined) {
        ranking[r] = [];
      }
      let rankingDivision = rankingPerDivision[r];

      this.props.players
        .filter((p) => {
          const team = this.props.teamsByKey[p.team] || {};
          return team.division === r;
        })
        .forEach((p) => {
          if (!rankingDivision[p.id]) {
            rankingDivision[p.id] = {};
          }
          const team = this.props.teamsByKey[p.team];
          if (team) {
            (p.matches || []).forEach((m) => {
              if (
                matchIdsPerTeam[team.id] &&
                matchIdsPerTeam[team.id].includes(m) &&
                playerPointsPlayedKey
              ) {
                if (!rankingDivision[p.id][playerPointsPlayedKey]) {
                  rankingDivision[p.id][playerPointsPlayedKey] = 1;
                } else {
                  rankingDivision[p.id][playerPointsPlayedKey]++;
                }
              }
            });
          }
        });
      let sortedPlayers = this.props.players
        .filter((p) => {
          let team = this.props.teamsByKey[p.team] || {};
          return team.division === r;
        })
        .sort((a, b) => {
          let playerA = (rankingDivision[a.id] || {})[this.state.sort] || 0;
          let playerB = (rankingDivision[b.id] || {})[this.state.sort] || 0;
          if (playerA > playerB) {
            return -1;
          } else if (playerA < playerB) {
            return 1;
          } else {
            return 0;
          }
        });
      sortedPlayers.forEach((p) => {
        let result = rankingDivision[p.id] || {};
        const team = this.props.teamsByKey[p.team] || {};

        result["name"] =
          (p.name || "") +
          (p.number ? ` (${p.number})` : "") +
          " - " +
          (team.gamertag || team.name || "");
        ranking[r].push(result);
      });
    });
    return (
      <div>
        {this.props.divisions.length > 1 ? (
          <DivisionTabsContainer
            tournament={this.props.tournament}
            divisions={this.props.divisions}
            divisionsObject={this.props.divisionsObject}
            rankingPlayers={ranking}
            playerRankingPage={true}
            resultsPage={true}
            sort={this.state.sort}
            handleSortChange={this.handleSortChange}
            selectedPhase={this.state.selectedPhase}
            anchorElPhase={this.state.anchorElPhase}
            handleMenuPhase={this.handleMenuPhase}
            handleClosePhase={this.handleClosePhase}
            selectPhase={this.selectPhase}
          />
        ) : (
          <PlayerRankingTable
            tournament={this.props.tournament}
            ranking={ranking[0] || []}
            division={"0"}
            sort={this.state.sort}
            handleSortChange={this.handleSortChange}
            divisionsObject={this.props.divisionsObject}
            selectedPhase={this.state.selectedPhase}
            anchorElPhase={this.state.anchorElPhase}
            handleMenuPhase={this.handleMenuPhase}
            handleClosePhase={this.handleClosePhase}
            selectPhase={this.selectPhase}
          />
        )}
      </div>
    );
  }
}

export default PlayerRankingContainer;
